import { get, isNil } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

const withPaginatedStoreHelpers = (paginatedStore) => {
  return compose(
    connect(
      (state) => {
        const pageInfo = paginatedStore.selectors.getActivePageInfo(state);
        const activePage = get(pageInfo, 'page', null);
        const totalPages = get(pageInfo, 'totalPages', null);
        const isFetchingPage = paginatedStore.selectors.getBusyState(state);
        const canPerformAction = !isFetchingPage && !isNil(activePage);

        return {
          activePage,
          isFetchingPage,
          totalPages,
          totalItems: get(pageInfo, 'count', null),
          itemsPerPage: get(pageInfo, 'perPage', null),
          activePageItems: paginatedStore.selectors.getActivePageItems(state),
          canOpenNextPage: canPerformAction && activePage > totalPages,
          canOpenPreviousPage: canPerformAction && activePage > 0,
        };
      },
      { ...paginatedStore.actions },
    ),
    withHandlers({
      withActionGuard: props => (fn) => {
        return (...args) => {
          const canExecuteAction = !props.isFetchingPage;
          if (canExecuteAction) {
            return fn(...args);
          }

          return Promise.reject(new Error('Action cannot be executed at the moment'));
        };
      },
    }),
    withHandlers({
      openNextPage: props => props.withActionGuard(() => {
        if (props.canOpenNextPage) {
          return props.fetchPage(props.activePage + 1);
        }

        return Promise.reject(new Error('Next page is not available'));
      }),
      openPreviousPage: props => props.withActionGuard(() => {
        if (props.canOpenPreviousPage) {
          return props.fetchPage(props.activePage - 1);
        }

        return Promise.reject(new Error('Previous page is not available'));
      }),
      openPage: props => props.withActionGuard((page) => {
        return props.fetchPage(page);
      }),
      refreshPageData: props => props.withActionGuard(() => {
        return props.fetchPage(props.activePage);
      }),
    }),
  );
};

export default withPaginatedStoreHelpers;
